// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-UL1RU";
var _4 = "text-Swr_5";
var _5 = "icon-Sfs-6";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "text", _5 as "icon" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "text": _4, "icon": _5 }
